import { createToastStore } from "./toastStore";

const toastStore = createToastStore();

export const useToast = toastStore;
